/**
 * Centralized registry for feed-related React Query keys.
 *
 * Mirrors `@lib/cache/questions` / `@lib/cache/spaces` (issue #653: "No raw
 * strings for cache keys"). Promoting the detector key here lets both its
 * producer (`useNewMeetversePostsIndicator`) and its SSE invalidator
 * (`useRealtimeInvalidation`'s `feed.new_top_post` handler) reference one
 * factory instead of importing a const out of a hook module — which would drag
 * the hook's `@providers` / `@api-client` graph into the SSE handler.
 */

/**
 * New-posts-pill detector cache for the Meetverse home feed.
 *
 * Lives OUTSIDE the `['questions', ...]` tree on purpose: `setQueriesData({
 * queryKey: ['questions', 'meetverse'] })` in `useCreateQuestionCache`
 * prefix-matches every child and would corrupt this single-page detector
 * response by prepending a `QuestionRead` onto it. Keep it under its own
 * `['detector', ...]` root.
 */
export const detectorMeetverseKey = () => ['detector', 'meetverse'] as const;
